import type { School, SchoolUser } from "shared/types/school.types";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const schoolUserFromDto = (dto: any): SchoolUser => ({
  id: dto.id,
  lvsUuid: dto.lvs_uuid,
  ssoId: dto.sso_id,
  ssoIds: dto.sso_ids,
  somtodayUuid: dto.somtoday_uuid,
  schoolId: dto.school_id,
  shortage: dto.shortage,
  studentNumber: dto.student_number,
  firstName: dto.first_name,
  middleName: dto.middle_name,
  lastName: dto.last_name,
  email: dto.email,
  emailVerifiedAt: dto.email_verified_at,
  profileImage: dto.profile_image,
  verified: dto.verified === 1,
  isNew: dto.is_new === 1,
  signinCounter: dto.signin_counter,
  nps: dto.nps === 1,
  question: dto.question === 1,
  uniqueId: dto.unique_id,
  createdAt: new Date(dto.created_at),
  updatedAt: new Date(dto.updated_at),
  roleId: dto.role_id,
  modelType: dto.model_type,
  modelId: dto.model_id,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const schoolFromDto = (dto: any): School => ({
  id: dto.id,
  name: dto.name,
  sso: dto.sso,
  ssoBrin: dto.sso_brin,
  brinCodes: dto.brin_codes,
  tool: dto.tool,
  plusdoc: dto.plusdoc,
  plusdocAmount: dto.plusdoc_amount,
  ratingsModule: dto.ratings_module,
  isCancelled: dto.is_cancelled,
  isDemo: dto.is_demo,
  isOnboarded: dto.is_onboarded,
  deactivatedAt: dto.deactivated_at ?? null,
  deletableAt: dto.deletable_at ?? null,
  startSchoolyear: dto.start_schoolyear,
  ssoAuthsource: dto.sso_authsource,
  package: dto.package,
  studentLicenseAmount: dto.student_license_amount,
  studentAmount: dto.student_amount,
  licenseExpiryDate: dto.license_expiry_date,
  advisor: dto.advisor,
  lvs: dto.lvs,
  manageData: dto.manage_data,
  autoSync: dto.auto_sync,
  setPortfolio: dto.set_portfolio,
  nps: dto.nps,
  emailHelp: dto.email_help,
  emailSync: dto.email_sync,
  emailLicense: dto.email_license,
  learningObjectiveModule: dto.learning_objective_module,
  allowAi: dto.allow_ai,
  type: dto.type,
  users: dto.users.map(schoolUserFromDto),
});
